import React from "react";
import type { Theme } from "@material-ui/core";
import { ListItemIcon as UIListItemIcon, makeStyles, createStyles } from "@material-ui/core";
import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export type ListItemIconProps = {
    icon?: IconProp;
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            fontSize: theme.typography.pxToRem(20),
        },
    }),
);

/**
 * Based on MUI ListItemIcon, suitable in Lists and Menus
 */
export const ListItemIcon = (props: ListItemIconProps) => {
    const classes = useStyles();
    return (
        <UIListItemIcon classes={{ root: classes.root }}>
            {props.icon ? <FontAwesomeIcon icon={props.icon} fixedWidth /> : <></>}
        </UIListItemIcon>
    );
};
